/*jshint loopfunc: true */


/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  var swiping = false;
  var scroll_direction = 'down';
  var youtube_players = {};

  function watchNavigationScroll() {
    if( $(window).scrollTop() > 0 ) {
      $('body').addClass('scrolled');
    }
    else {
      $('body').removeClass('scrolled');
    }
  }

  function partInViewport(elem) {
    var x = elem.get(0).getBoundingClientRect().left;
    var y = elem.get(0).getBoundingClientRect().top;
    var ww = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    var hw = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    var w = elem.get(0).clientWidth;
    var h = elem.get(0).clientHeight;
    return (
        (y < hw &&
         y + h > 0) &&
        (x < ww &&
         x + w > 0)
    );
  }

  function getCurrentProcess( section ) {
    var process = null;

    section.find('.process-position-watcher .item').each(function () {
      if ($(this).visible()) {
        process = $(this);
      }
    });

    if (!process) {
      $('.process-position-watcher .item').each(function () {
        if ($(this).visible(true)) {
          process = $(this);
        }
      });
    }

    if (process && process.length) {
      return process.attr('data-position');
    }
    else {
      return 0;
    }
  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        watchNavigationScroll();

        $(window).on('load resize scroll orientationchange', function() {
          watchNavigationScroll();
        });

        $(document).on('click', '.menu-toggle', function(e) {
          e.preventDefault();

          $('body').toggleClass('nav-on');
        });

        $(document).on('click', '.section-process .toggle-link', function(e) {
          e.preventDefault();

          var this_step = $(this).closest('.process-item'),
              active_step = this_step.closest('section').find('.process-item.on');

          if( this_step.hasClass('on') ) {
            return false;
          }

          active_step.removeClass('on').find('.text-and-links').slideUp('fast');
          this_step.addClass('on').find('.text-and-links').slideDown('fast');
        });

        $('.section-people-carousel .people-carousel').slick({
          autoplay: true,
          autoplaySpeed: 5000,
          dots: false,
          arrows: true,
          slidesToShow: 3,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 520,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });

        $('.section-logos-carousel .logos-carousel-side').slick({
          autoplay: true,
          autoplaySpeed: 5000,
          dots: false,
          arrows: true,
          slidesToShow: 3,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2
              }
            }
          ]
        });

        $('.section-logos-carousel .logos-carousel-full').slick({
          autoplay: true,
          autoplaySpeed: 5000,
          dots: false,
          arrows: true,
          slidesToShow: 4,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2
              }
            }
          ]
        });

        $('.modal-video').magnificPopup({
          type: 'iframe',
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false
        });

        $('.custom-carousel').each(function() {
          var t = $(this);

          if( !t.closest('.section-process').length ) {
            if( !t.attr('data-disable-js') ) {
              var atts = {
                dots: false,
                arrows: false,
                autoplay: false,
                pauseOnHover: false,
              };

              if( t.attr('data-slides-to-show') ) {
                atts.slidesToShow = parseInt( t.attr('data-slides-to-show') );
                atts.slidesToScroll = parseInt( t.attr('data-slides-to-show') );
              }

              if( t.attr('data-autoplay-speed') ) {
                atts.autoplay = true;
                atts.autoplaySpeed = parseInt( t.attr('data-autoplay-speed') );
              }

              if( t.attr('data-transition-mode') && t.attr('data-transition-mode') === "fade" ) {
                atts.fade = true;
              }

              if( t.attr('data-transition-direction') && t.attr('data-transition-direction') === "vertical" ) {
                atts.vertical = true;
                atts.verticalSwiping = true;
              }

              if( t.closest('[data-scroll-locked]').length ) {
                // atts.swipe = false;
                // atts.draggable = false;
                // atts.infinite = false;
                atts.speed = 1500;
                // atts.accessibility = false;
                // atts.autoplay = false;

                atts.responsive = [
                  {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                      centerMode: false,
                      centerPadding: '100px',
                      autoplay: true,
                      autoplaySpeed: 5000,
                      infinite: true,
                      accessibility: true,
                      swipe: true,
                      draggable: true,
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                      centerMode: false,
                      centerPadding: '60px',
                      autoplay: true,
                      autoplaySpeed: 5000,
                      infinite: true,
                      accessibility: true,
                      swipe: true,
                      draggable: true,
                    }
                  }
                ];

                if( atts.slidesToShow && atts.slidesToShow > 2 ) {
                  atts.responsive.push({
                    breakpoint: 1100,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  });
                }

                t.on('beforeChange', function(){
                  swiping = true;
                });

                t.on('afterChange', function(){
                  swiping = false;
                });
              }

              t.slick( atts );
            }
          }
        });

        var sticky_sidebars = {};
        var sticky_slicks = {};

        $('.section-process').each(function() {
          var section = $(this);
          var idx = section.attr('section-idx');

          sticky_sidebars[ idx ] = new StickySidebar('.section-process[section-idx="'+idx+'"] .carousel-column', {
            containerSelector: '.section-process[section-idx="'+idx+'"] .container',
            innerWrapperSelector: '.carousel-column-inner'
          });

          sticky_slicks[ idx ] = section.find('.custom-carousel').slick({
            speed: 700,
            swipe: false,
            touchMove: false,
            infinite: false,
            autoplay: false,
            dots: false,
            arrows: false,
            fade: true,
            responsive: [{
              breakpoint: 768,
              settings: {
                swipe: true,
                touchMove: true,
              }
            }]
          }).css('opacity', 1);

          var current_process = getCurrentProcess( section );

          sticky_slicks[ idx ].slick('slickGoTo', current_process);

          $(window).on('load resize scroll', function () {
            if (!$('#mobile-observer').is(':visible')) {
              current_process = getCurrentProcess( section );

              sticky_slicks[ idx ].slick('slickGoTo', current_process);
            }
          });
        });

        $('.section-homepage-slideshow .slick-slider, .section-internal-page-slideshow .slick-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
          $(this).find('.part-quarter').stop().css('margin-left', '0px');
        });

        $('.section-homepage-slideshow .slick-slider, .section-internal-page-slideshow .slick-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
          if( $('#mobile-observer').is(':visible') ) {
            return false;
          }

          var sts = $(this).slick('slickGetOption', 'slidesToShow');

          var current_part = 1;
          var next_part = 1;

          var next_idxs = [];

          for(var i=0; i<sts; i++) {
            $(this).find('.item-slide[data-slick-index="' + (nextSlide+i) + '"]').each(function() {
              if( $(this).length ) {
                next_idxs.push( nextSlide+i );
              }
            });
          }

          // if (Math.abs(nextSlide - currentSlide) == 1) {
          //   direction = (nextSlide - currentSlide > 0) ? "right" : "left";
          // }
          // else {
          //   direction = (nextSlide - currentSlide > 0) ? "left" : "right";
          // }

          if (currentSlide === 0 && nextSlide === slick.$slides.length - 1) {
            // its going from the first slide to the last slide (backwards)
            direction = 'right';
          } else if (nextSlide > currentSlide || (currentSlide === (slick.$slides.length - 1) && nextSlide === 0 )) {
            // its either going normally forwards or going from the last slide to the first
            direction = 'left';
          } else {
            direction = 'right';
          }

          // console.log( direction, currentSlide, nextSlide );

          for(i=0; i<sts; i++) {
            if( direction === "left" ) {
              $(this).find('.item-slide[data-slick-index="' + (currentSlide+i) + '"]').find('.slide-part').each(function() {
                if( next_idxs.length === sts ) {
                  $(this).find('.part-quarter').each(function() {
                    var t = $(this);

                    t.stop().animate({
                      'margin-left': '-250px'
                    }, current_part*100);
                  });

                  current_part++;
                }
              });

              $(this).find('.item-slide[data-slick-index="' + (nextSlide+i) + '"]').find('.slide-part').each(function() {
                $(this).find('.part-quarter').each(function() {
                  var t = $(this);

                  t.css({
                    'margin-left': (next_part*80)+'px'
                  });

                  setTimeout(function() {
                    t.stop().animate({
                      'margin-left': '0px'
                    }, 1500);
                  }, next_part*5);
                });

                next_part++;
              });
            }
            else {
              $(this).find('.part-quarter').css({'margin-left': 0});
            }
          }
        });

        // t.closest('.slideshow-wrapper').find('.slideshow-scroll-detect').mousewheel(function(e) {
        /*
        $('#page').mousewheel(function(e) {
          if( $('#mobile-observer').is(':visible') ) {
            return;
          }

          if( swiping ) {
            e.preventDefault();
            e.stopPropagation();
          }

          $('[data-scroll-locked="true"]').each(function() {
            if( partInViewport( $(this) ) ) {
              var scroll_locked_section = $(this);
              var section = $(this).closest('section');

              if( !scroll_locked_section.attr('moved-at-top') && ( scroll_locked_section.parents('section').last().attr('section-idx') !== "0" || ( section.find('.section-position-detect').offset().top != section.find('.slideshow-position-detect').offset().top ) ) ) {
                $('html,body').stop().animate({
                  scrollTop: scroll_locked_section.offset().top - $('#header').outerHeight() - 20
                }, 'slow');

                scroll_locked_section.attr('moved-at-top', true);
              }

              var t = scroll_locked_section.closest('section').find('.slick-slider');

              if( !t.attr('last-slide-reached') ) {
                var current_slide = t.find('.slick-active:last').attr('data-slick-index');

                if ( e.deltaY < 0 ) { //scroll down
                  scroll_direction = 'down';

                  if( current_slide == t.attr('data-slides-count') - 1 && !swiping ) {
                    t.attr('last-slide-reached', true);

                    return;
                  }

                  e.preventDefault();
                  t.slick('slickNext');
                } else { //scroll up
                  scroll_direction = 'up';

                  if( current_slide == 0 && !swiping ) {
                    return;
                  }

                  e.preventDefault();
                  t.slick('slickPrev');
                }
              }

              return false;
            }
          });
        });
        */
        function init() {
          var vidDefer = document.getElementsByTagName('iframe');
          for (var i=0; i<vidDefer.length; i++) {
          if(vidDefer[i].getAttribute('data-src')) {
            console.log('change attr');
            vidDefer[i].setAttribute('src',vidDefer[i].getAttribute('data-src'));
          } } }
        window.onload = init;
       

        $(document).on('click', 'a[href*="#"]', function(e) {
          var split = $(this).attr('href').split('#');

          if( split[1] ) {
            var target = $('#' + split[1]);

            if( target.length ) {
              e.preventDefault();

              $('html,body').stop().animate({
                scrollTop: target.offset().top - 100
              }, 'slow');
            }
          }
        });

        window.onYouTubeIframeAPIReady = function(){
          $('.youtube-player-iframe').each(function() {
            var section_id = $(this).closest('section').attr('section-idx');
            var player_id = $(this).attr('id');

            if( typeof YT === "object" ) {
              var player = new YT.Player( player_id);

              if( player ) {
                youtube_players[section_id] = player;
              }
            }
          });
        };
        
        $(document).on('click', '.replace-youtube-video', function(e) {
          e.preventDefault();

          var section = $(this).closest('section');
          var section_id = section.attr('section-idx');
          var youtube_player_iframe = section.find('.youtube-player-iframe');
          var video_id = $(this).attr('data-video');

          if( youtube_player_iframe.length ) {
            // if( typeof YT === "object" && youtube_players[ section_id ] ) {
            //   var player = youtube_players[ section_id ];

            //   player.loadVideoById(video_id);

            //   // player.playVideo();
            // }
            // else {
              youtube_player_iframe.attr('src', 'https://www.youtube.com/embed/' + video_id + '?feature=oembed');
            // }

            $('html,body').stop().animate({
              scrollTop: youtube_player_iframe.offset().top - 100
            }, 'slow');
          }
        });

        $('.section-stats-type-2 p img').addClass('wow fadeIn').removeAttr('loading');

        var wow = new WOW(
          {
            boxClass: 'wow',      // animated element css class (default is wow)
            animateClass: 'animated', // animation css class (default is animated)
            offset: 350,          // distance to the element when triggering the animation (default is 0)
            mobile: true,       // trigger animations on mobile devices (default is true)
            live: true,       // act on asynchronously loaded content (default is true)
            callback: function (box) {
              // the callback is fired every time an animation is started
              // the argument that is passed in is the DOM node being animated
            },
            scrollContainer: null // optional scroll container selector, otherwise use window
          }
        );
        wow.init();

        $('.modal').appendTo('body');
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


(function ($) {

	/**
	 * Copyright 2012, Digital Fusion
	 * Licensed under the MIT license.
	 * http://teamdf.com/jquery-plugins/license/
	 *
	 * @author Sam Sehnert
	 * @desc A small plugin that checks whether elements are within
	 *		 the user visible viewport of a web browser.
	 *		 only accounts for vertical position, not horizontal.
	 */
  $.fn.visible = function (partial) {

    var $t = $(this),
      $w = $(window),
      viewTop = $w.scrollTop(),
      viewBottom = viewTop + $w.height(),
      _top = $t.offset().top,
      _bottom = _top + $t.height(),
      compareTop = partial === true ? _bottom : _top,
      compareBottom = partial === true ? _top : _bottom;

    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
  };

  $.fn.random = function () {
    var randomIndex = Math.floor(Math.random() * this.length);
    return jQuery(this[randomIndex]);
  };
})(jQuery);
